import { render } from "./NewReferralInformation.vue?vue&type=template&id=4d9511ac&ts=true"
import script from "./NewReferralInformation.ts?vue&type=script&lang=ts&external"
export * from "./NewReferralInformation.ts?vue&type=script&lang=ts&external"

import "./NewReferralInformation.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__